import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMatrixRooms } from '../../../../../shared/actions/matrixAction';
import { getMatrixRoomsArray } from '../../../../../shared/utils/chatUtil';

/**
 * Matrix room list sync, room metadata from Redux, and SDK room object for the call route.
 */
export function useCallingScreenMatrixRoom({ client, roomId }) {
  const dispatch = useDispatch();
  const matrixRooms = useSelector((state) => state.matrix?.rooms || {});
  const matrixLoading = useSelector((state) => state.matrix?.loading);
  const hasRoomsLoaded = useSelector((state) => state.matrix?.hasRoomsLoaded);

  const matrixRoomsArray = useMemo(() => getMatrixRoomsArray(matrixRooms), [matrixRooms]);
  const roomMetadata = useMemo(
    () => matrixRoomsArray.find((room) => room?.roomid === roomId) || null,
    [matrixRoomsArray, roomId]
  );
  const resolvedUserId = roomMetadata?.otherUser?._id ?? null;
  const targetSubscriberId = roomMetadata?.otherUser?._id || roomMetadata?.otherUser?.id || null;

  useEffect(() => {
    if (!roomId) return;
    if (hasRoomsLoaded) return;
    if (matrixLoading) return;
    dispatch(fetchMatrixRooms());
  }, [dispatch, roomId, hasRoomsLoaded, matrixLoading]);

  const matrixRoom = useMemo(() => {
    try {
      if (!client || !roomId) return null;
      return client.getRoom?.(roomId) || null;
    } catch {
      return null;
    }
  }, [client, roomId]);

  return {
    matrixRoomsArray,
    roomMetadata,
    resolvedUserId,
    targetSubscriberId,
    matrixRoom,
    matrixLoading,
    hasRoomsLoaded,
  };
}
